var render = function render(){
  var _vm$config$general, _vm$config$general2, _vm$config$general3, _vm$config$general4, _vm$config$labels, _vm$config$labels2, _vm$config$labels3, _vm$config$labels4, _vm$config$labels5, _vm$config$labels6, _vm$config$labels7, _vm$config$labels8, _vm$config$labels9, _vm$config$labels10, _vm$config$labels11, _vm$config$labels12, _vm$config$labels13, _vm$config$labels14, _vm$config$labels15, _vm$config$labels16, _vm$config$labels17, _vm$config$labels18, _vm$config$labels19, _vm$config$labels20, _vm$config$labels21, _vm$config$labels22, _vm$config$labels23, _vm$config$labels24, _vm$config$labels25, _vm$config$labels26, _vm$config$labels27, _vm$config$labels28, _vm$config$labels29, _vm$config$labels30, _vm$config$labels31, _vm$config$labels32, _vm$config$labels33, _vm$config, _vm$config$labels34, _vm$config$labels35, _vm$config$labels36, _vm$config$labels37, _vm$config$labels38, _vm$config$labels39, _vm$config$labels40, _vm$config$labels41, _vm$config$labels42, _vm$config$labels43, _vm$config$labels44, _vm$config$labels45, _vm$config$labels46, _vm$config$labels47, _vm$config$labels48, _vm$config$labels49, _vm$config$labels50, _vm$config$labels51, _vm$config$labels52, _vm$config$labels53, _vm$config$labels54, _vm$config$labels55, _vm$config$labels56, _vm$config$labels57, _vm$config$labels58, _vm$config$labels59, _vm$config$labels60, _vm$config$general5, _vm$config$labels61, _vm$config$labels62, _vm$config$propertyMo, _vm$config$propertyMo2, _vm$config$propertyMo3, _vm$property$descript, _vm$property$descript2, _vm$property$descript3, _vm$property$descript4, _vm$property$dwelling, _vm$property$dwelling2, _vm$property$dwelling3, _vm$property$dwelling4, _vm$property$dwelling5, _vm$property$dwelling6, _vm$property$dwelling7, _vm$property$dwelling8, _vm$property$dwelling9, _vm$property$dwelling10;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('transition', {
    attrs: {
      "name": "fast-fade"
    }
  }, [_vm.property ? _c('div', {
    staticClass: "property-modal",
    class: {
      'has-features': _vm.showFeatures,
      'turnkey': _vm.isTurnkey
    }
  }, [_c('div', {
    staticClass: "property-modal__mask",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.closeModal.apply(null, arguments);
      }
    }
  }), _c('div', {
    staticClass: "property-modal__inner"
  }, [_c('div', [(_vm$config$general = _vm.config.general) !== null && _vm$config$general !== void 0 && _vm$config$general.showOnHoldGraphic && _vm.property.status === 'on-hold' ? _c('div', {
    staticClass: "property-modal__status",
    class: "property-modal__status--".concat(_vm.property.status)
  }) : _vm._e(), (_vm$config$general2 = _vm.config.general) !== null && _vm$config$general2 !== void 0 && _vm$config$general2.showArtistImpressionText ? _c('div', {
    staticClass: "property-modal__note",
    class: "property-modal__note--".concat((_vm$config$general3 = _vm.config.general) === null || _vm$config$general3 === void 0 ? void 0 : _vm$config$general3.artistImpressionPosition)
  }, [_vm._v("Artist impression only")]) : _vm._e(), _c('div', {
    staticClass: "property-modal__gallery",
    class: {
      'property-modal__gallery--video': _vm.activeVideo,
      'property-modal__gallery--view-image': _vm.isActiveViewImage
    }
  }, [_vm.overlayImageUrl && _vm.imageIndex === 0 ? _c('img', {
    staticClass: "property-modal__overlay-image",
    attrs: {
      "src": _vm.overlayImageUrl
    }
  }) : _vm._e(), _vm.activeImage ? _c('img', {
    key: _vm.activeImage,
    class: {
      touch: _vm.imageIndex === _vm.images.length - 1
    },
    attrs: {
      "src": "".concat(_vm.activeImage)
    },
    on: {
      "click": _vm.openVirtualTour
    }
  }) : _vm._e(), _vm.activeVideo ? [_c('video', {
    key: _vm.activeVideo,
    ref: "video",
    attrs: {
      "src": "".concat(_vm.activeVideo),
      "loop": "",
      "muted": "",
      "autoplay": "",
      "playsinline": "",
      "preload": "auto",
      "disablePictureInPicture": "",
      "poster": "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
    },
    domProps: {
      "muted": true
    },
    on: {
      "play": function play($event) {
        _vm.videoStatus = 'playing';
      },
      "pause": function pause($event) {
        _vm.videoStatus = 'paused';
      },
      "loadedmetadata": _vm.updateVideoProgress,
      "timeupdate": _vm.updateVideoProgress
    }
  }), _c('div', {
    staticClass: "property-modal__video-controls"
  }, [_c('button', {
    staticClass: "property-modal__video-playback touch",
    attrs: {
      "type": "button",
      "aria-label": _vm.videoStatus === 'playing' ? 'Pause video' : 'Play video'
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.toggleVideoPlayback.apply(null, arguments);
      }
    }
  }, [_vm.videoStatus === 'playing' ? _c('fa', {
    attrs: {
      "icon": ['fal', 'pause']
    }
  }) : _c('fa', {
    attrs: {
      "icon": ['fas', 'play']
    }
  })], 1), _c('input', {
    staticClass: "property-modal__video-scrubber",
    style: {
      '--video-progress': "".concat(_vm.videoProgress, "%")
    },
    attrs: {
      "type": "range",
      "min": "0",
      "max": _vm.videoDuration,
      "step": "0.1",
      "disabled": !_vm.videoDuration,
      "aria-label": "Video timeline"
    },
    domProps: {
      "value": _vm.videoCurrentTime
    },
    on: {
      "pointerdown": _vm.startVideoScrubbing,
      "input": _vm.scrubVideo,
      "change": _vm.finishVideoScrubbing,
      "pointerup": _vm.finishVideoScrubbing,
      "pointercancel": _vm.finishVideoScrubbing
    }
  })])] : _vm._e(), _vm.isActiveViewImage && _vm.$label((_vm$config$general4 = _vm.config.general) === null || _vm$config$general4 === void 0 ? void 0 : _vm$config$general4.propertyModalViewImagesDisclaimer) ? _c('div', {
    staticClass: "property-modal__view-images-disclaimer",
    domProps: {
      "innerHTML": _vm._s(_vm.$label(_vm.config.general.propertyModalViewImagesDisclaimer))
    }
  }) : _vm._e(), _vm.images.length > 1 && !_vm.activeVideo ? _c('div', {
    staticClass: "property-modal__swipe-layer",
    on: {
      "touchstart": function touchstart($event) {
        return _vm.handleTouchStart($event);
      },
      "touchmove": function touchmove($event) {
        return _vm.handleTouchMove($event);
      },
      "touchend": function touchend($event) {
        return _vm.handleTouchEnd($event);
      },
      "touchcancel": _vm.resetTouchState
    }
  }) : _vm._e(), _c('div', {
    staticClass: "property-modal__controls"
  }, [_vm.images.length > 1 ? _c('div', {
    staticClass: "prev"
  }, [_c('button', {
    staticClass: "btn-circle touch nav-button",
    class: {
      inactive: _vm.imageIndex <= 0
    },
    on: {
      "click": _vm.goToPrevImage
    }
  }, [_c('div', {
    staticClass: "nav-button__ring"
  }), _c('fa', {
    attrs: {
      "icon": ['far', 'chevron-left']
    }
  })], 1)]) : _vm._e(), _vm.images.length > 1 ? _c('div', {
    staticClass: "next"
  }, [_c('button', {
    staticClass: "btn-circle touch nav-button",
    class: {
      inactive: _vm.imageIndex >= _vm.images.length - 1
    },
    on: {
      "click": _vm.goToNextImage
    }
  }, [_c('div', {
    staticClass: "nav-button__ring"
  }), _c('fa', {
    attrs: {
      "icon": ['far', 'chevron-right']
    }
  })], 1)]) : _vm._e()]), _vm.images.length > 1 ? _c('div', {
    staticClass: "property-modal__dots"
  }, _vm._l(_vm.images, function (image, index) {
    return _c('button', {
      key: "modal-dot-".concat(index),
      staticClass: "property-modal__dot touch",
      class: {
        'property-modal__dot--active': _vm.imageIndex === index
      },
      on: {
        "click": function click($event) {
          _vm.imageIndex = index;
        }
      }
    });
  }), 0) : _vm._e()], 2)]), _c('div', {
    staticClass: "property-modal__info"
  }, [_c('div', {
    staticClass: "detail-wrapper",
    attrs: {
      "dir": _vm.language.dir
    }
  }, [_vm.isDisplayHome ? _c('div', {
    staticClass: "details"
  }, [_vm.property.dwelling && (_vm.property.dwelling.builderLabel[_vm.language.code] || _vm.property.dwelling.builderLabel['en']) ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels = _vm.config.labels) === null || _vm$config$labels === void 0 ? void 0 : _vm$config$labels.dwellingBuilder[_vm.language.code]) || ((_vm$config$labels2 = _vm.config.labels) === null || _vm$config$labels2 === void 0 ? void 0 : _vm$config$labels2.dwellingBuilder["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.builderLabel[_vm.language.code] || _vm.property.dwelling.builderLabel["en"]))])]) : _vm._e(), _vm.displayHomeDesign ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels3 = _vm.config.labels) === null || _vm$config$labels3 === void 0 ? void 0 : _vm$config$labels3.dwellingDesign[_vm.language.code]) || ((_vm$config$labels4 = _vm.config.labels) === null || _vm$config$labels4 === void 0 ? void 0 : _vm$config$labels4.dwellingDesign["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.displayHomeDesign))])]) : _vm._e(), _vm.property.dwelling && _vm.property.dwelling.size ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels5 = _vm.config.labels) === null || _vm$config$labels5 === void 0 ? void 0 : _vm$config$labels5.dwellingSize[_vm.language.code]) || ((_vm$config$labels6 = _vm.config.labels) === null || _vm$config$labels6 === void 0 ? void 0 : _vm$config$labels6.dwellingSize["en"])))]), _c('div', {
    staticClass: "detail__value",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v(_vm._s(_vm.property.dwelling.size) + "m"), _c('sup', [_vm._v("2")])])]) : _vm._e(), _vm.property.dwelling && _vm.property.dwelling.beds ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels7 = _vm.config.labels) === null || _vm$config$labels7 === void 0 ? void 0 : _vm$config$labels7.dwellingBeds[_vm.language.code]) || ((_vm$config$labels8 = _vm.config.labels) === null || _vm$config$labels8 === void 0 ? void 0 : _vm$config$labels8.dwellingBeds["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.beds))])]) : _vm._e(), _vm.property.dwelling && _vm.property.dwelling.baths ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels9 = _vm.config.labels) === null || _vm$config$labels9 === void 0 ? void 0 : _vm$config$labels9.dwellingBaths[_vm.language.code]) || ((_vm$config$labels10 = _vm.config.labels) === null || _vm$config$labels10 === void 0 ? void 0 : _vm$config$labels10.dwellingBaths["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.baths))])]) : _vm._e(), _vm.property.dwelling && _vm.property.dwelling.cars ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels11 = _vm.config.labels) === null || _vm$config$labels11 === void 0 ? void 0 : _vm$config$labels11.dwellingCars[_vm.language.code]) || ((_vm$config$labels12 = _vm.config.labels) === null || _vm$config$labels12 === void 0 ? void 0 : _vm$config$labels12.dwellingCars["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.cars))])]) : _vm._e()]) : _vm.isTurnkey ? _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels13 = _vm.config.labels) === null || _vm$config$labels13 === void 0 ? void 0 : _vm$config$labels13.propertyLabel[_vm.language.code]) || ((_vm$config$labels14 = _vm.config.labels) === null || _vm$config$labels14 === void 0 ? void 0 : _vm$config$labels14.propertyLabel["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.label))])]), _vm.property.dwelling && (_vm.property.dwelling.displayName[_vm.language.code] || _vm.property.dwelling.displayName['en']) ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s((_vm$config$labels15 = _vm.config.labels) === null || _vm$config$labels15 === void 0 ? void 0 : _vm$config$labels15.dwellingLabel.en))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.displayName[_vm.language.code] || _vm.property.dwelling.displayName["en"]))])]) : _vm._e(), _vm.property.dwelling && (_vm.property.dwelling.houseDesign[_vm.language.code] || _vm.property.dwelling.houseDesign['en']) ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels16 = _vm.config.labels) === null || _vm$config$labels16 === void 0 ? void 0 : _vm$config$labels16.dwellingDesign[_vm.language.code]) || ((_vm$config$labels17 = _vm.config.labels) === null || _vm$config$labels17 === void 0 ? void 0 : _vm$config$labels17.dwellingDesign["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.houseDesign[_vm.language.code] || _vm.property.dwelling.houseDesign["en"]))])]) : _vm._e(), _vm.property.dwelling && (_vm.property.dwelling.builderLabel[_vm.language.code] || _vm.property.dwelling.builderLabel['en']) ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels18 = _vm.config.labels) === null || _vm$config$labels18 === void 0 ? void 0 : _vm$config$labels18.dwellingBuilder[_vm.language.code]) || ((_vm$config$labels19 = _vm.config.labels) === null || _vm$config$labels19 === void 0 ? void 0 : _vm$config$labels19.dwellingBuilder["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.builderLabel[_vm.language.code] || _vm.property.dwelling.builderLabel["en"]))])]) : _vm._e(), _vm.property && _vm.property.viewLabel && (_vm.property.viewLabel[_vm.language.code] || _vm.property.viewLabel.en) ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels20 = _vm.config.labels) === null || _vm$config$labels20 === void 0 ? void 0 : _vm$config$labels20.viewLabel[_vm.language.code]) || ((_vm$config$labels21 = _vm.config.labels) === null || _vm$config$labels21 === void 0 ? void 0 : _vm$config$labels21.viewLabel.en)))]), _c('div', {
    staticClass: "detail__value",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v(_vm._s(_vm.property.viewLabel[_vm.language.code]))])]) : _vm._e(), _vm.property && _vm.property.frontage ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(_vm.$label(_vm.config.labels.frontage)))]), _c('div', {
    staticClass: "detail__value",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v(_vm._s(_vm.property.frontage)), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$label(_vm.config.labels.frontageSuffix))
    }
  })])]) : _vm._e(), _vm.property && _vm.property.depth ? _c('div', {
    staticClass: "detail detail--depth"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels22 = _vm.config.labels) === null || _vm$config$labels22 === void 0 ? void 0 : _vm$config$labels22.depth[_vm.language.code]) || ((_vm$config$labels23 = _vm.config.labels) === null || _vm$config$labels23 === void 0 ? void 0 : _vm$config$labels23.depth["en"])))]), _c('div', {
    staticClass: "detail__value",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v(_vm._s(_vm.property.depth)), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$label(_vm.config.labels.depthSuffix))
    }
  })])]) : _vm._e(), _vm.property && _vm.property.landSize ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels24 = _vm.config.labels) === null || _vm$config$labels24 === void 0 ? void 0 : _vm$config$labels24.propertySize[_vm.language.code]) || ((_vm$config$labels25 = _vm.config.labels) === null || _vm$config$labels25 === void 0 ? void 0 : _vm$config$labels25.propertySize["en"])))]), _c('div', {
    staticClass: "detail__value",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v(_vm._s(_vm.property.landSize) + "m"), _c('sup', [_vm._v("2")])])]) : _vm._e(), _vm.property.dwelling && _vm.property.dwelling.size ? _c('div', {
    staticClass: "detail dwelling-size"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels26 = _vm.config.labels) === null || _vm$config$labels26 === void 0 ? void 0 : _vm$config$labels26.dwellingSize[_vm.language.code]) || ((_vm$config$labels27 = _vm.config.labels) === null || _vm$config$labels27 === void 0 ? void 0 : _vm$config$labels27.dwellingSize["en"])))]), _c('div', {
    staticClass: "detail__value",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v(_vm._s(_vm.property.dwelling.size) + "m"), _c('sup', [_vm._v("2")])])]) : _vm._e(), _vm.property.dwelling && _vm.property.dwelling.beds ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels28 = _vm.config.labels) === null || _vm$config$labels28 === void 0 ? void 0 : _vm$config$labels28.dwellingBeds[_vm.language.code]) || ((_vm$config$labels29 = _vm.config.labels) === null || _vm$config$labels29 === void 0 ? void 0 : _vm$config$labels29.dwellingBeds["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.beds))])]) : _vm._e(), _vm.property.dwelling && _vm.property.dwelling.baths ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels30 = _vm.config.labels) === null || _vm$config$labels30 === void 0 ? void 0 : _vm$config$labels30.dwellingBaths[_vm.language.code]) || ((_vm$config$labels31 = _vm.config.labels) === null || _vm$config$labels31 === void 0 ? void 0 : _vm$config$labels31.dwellingBaths["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.baths))])]) : _vm._e(), _vm.property.dwelling && _vm.property.dwelling.cars ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels32 = _vm.config.labels) === null || _vm$config$labels32 === void 0 ? void 0 : _vm$config$labels32.dwellingCars[_vm.language.code]) || ((_vm$config$labels33 = _vm.config.labels) === null || _vm$config$labels33 === void 0 ? void 0 : _vm$config$labels33.dwellingCars["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.cars))])]) : _vm._e(), (_vm$config = _vm.config) !== null && _vm$config !== void 0 && _vm$config.general.showPrice && _vm.property.price && (_vm.property.status !== 'sold' || _vm.property.status === 'sold' && _vm.config.general.showSoldPrice) ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels34 = _vm.config.labels) === null || _vm$config$labels34 === void 0 ? void 0 : _vm$config$labels34.propertyPrice[_vm.language.code]) || ((_vm$config$labels35 = _vm.config.labels) === null || _vm$config$labels35 === void 0 ? void 0 : _vm$config$labels35.propertyPrice["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.price))])]) : _vm._e()]) : _c('div', {
    staticClass: "details"
  }, [_vm.isHouse && _vm.property.dwelling && (_vm.property.dwelling.displayName[_vm.language.code] || _vm.property.dwelling.displayName.en) ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels36 = _vm.config.labels) === null || _vm$config$labels36 === void 0 ? void 0 : _vm$config$labels36.dwellingLabel[_vm.language.code]) || ((_vm$config$labels37 = _vm.config.labels) === null || _vm$config$labels37 === void 0 ? void 0 : _vm$config$labels37.dwellingLabel["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.displayName[_vm.language.code] || _vm.property.dwelling.displayName.en))])]) : _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s((_vm$config$labels38 = _vm.config.labels) === null || _vm$config$labels38 === void 0 ? void 0 : _vm$config$labels38.propertyLabel[_vm.language.code]))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.label))])]), _vm.property.dwelling && (_vm.property.dwelling.builderLabel[_vm.language.code] || _vm.property.dwelling.builderLabel['en']) ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels39 = _vm.config.labels) === null || _vm$config$labels39 === void 0 ? void 0 : _vm$config$labels39.dwellingBuilder[_vm.language.code]) || ((_vm$config$labels40 = _vm.config.labels) === null || _vm$config$labels40 === void 0 ? void 0 : _vm$config$labels40.dwellingBuilder["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.builderLabel[_vm.language.code] || _vm.property.dwelling.builderLabel["en"]))])]) : _vm._e(), false && _vm.property.dwelling && (_vm.property.dwelling.houseDesign[_vm.language.code] || _vm.property.dwelling.houseDesign['en']) ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels41 = _vm.config.labels) === null || _vm$config$labels41 === void 0 ? void 0 : _vm$config$labels41.dwellingDesign[_vm.language.code]) || ((_vm$config$labels42 = _vm.config.labels) === null || _vm$config$labels42 === void 0 ? void 0 : _vm$config$labels42.dwellingDesign["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.houseDesign[_vm.language.code] || _vm.property.dwelling.houseDesign["en"]))])]) : _vm._e(), false && _vm.property.dwelling && _vm.property.dwelling.label ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels43 = _vm.config.labels) === null || _vm$config$labels43 === void 0 ? void 0 : _vm$config$labels43.dwellingLabel[_vm.language.code]) || ((_vm$config$labels44 = _vm.config.labels) === null || _vm$config$labels44 === void 0 ? void 0 : _vm$config$labels44.dwellingLabel["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.label))])]) : _vm._e(), _vm.property && _vm.property.frontage ? _c('div', {
    staticClass: "detail detail--frontage"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels45 = _vm.config.labels) === null || _vm$config$labels45 === void 0 ? void 0 : _vm$config$labels45.frontage[_vm.language.code]) || ((_vm$config$labels46 = _vm.config.labels) === null || _vm$config$labels46 === void 0 ? void 0 : _vm$config$labels46.frontage["en"])))]), _c('div', {
    staticClass: "detail__value",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v(_vm._s(_vm.property.frontage) + "m")])]) : _vm._e(), _vm.property && _vm.property.depth ? _c('div', {
    staticClass: "detail detail--depth"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels47 = _vm.config.labels) === null || _vm$config$labels47 === void 0 ? void 0 : _vm$config$labels47.depth[_vm.language.code]) || ((_vm$config$labels48 = _vm.config.labels) === null || _vm$config$labels48 === void 0 ? void 0 : _vm$config$labels48.depth["en"])))]), _c('div', {
    staticClass: "detail__value",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v(_vm._s(_vm.property.depth) + "m")])]) : _vm._e(), !_vm.property.isDisplayHome && _vm.property.landSize ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels49 = _vm.config.labels) === null || _vm$config$labels49 === void 0 ? void 0 : _vm$config$labels49.propertySize[_vm.language.code]) || ((_vm$config$labels50 = _vm.config.labels) === null || _vm$config$labels50 === void 0 ? void 0 : _vm$config$labels50.propertySize["en"])))]), _c('div', {
    staticClass: "detail__value",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v(_vm._s(_vm.property.landSize) + "m"), _c('sup', [_vm._v("2")])])]) : _vm._e(), _vm.property.dwelling && _vm.property.dwelling.size ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels51 = _vm.config.labels) === null || _vm$config$labels51 === void 0 ? void 0 : _vm$config$labels51.dwellingSize[_vm.language.code]) || ((_vm$config$labels52 = _vm.config.labels) === null || _vm$config$labels52 === void 0 ? void 0 : _vm$config$labels52.dwellingSize["en"])))]), _c('div', {
    staticClass: "detail__value",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v(_vm._s(_vm.property.dwelling.size) + "m"), _c('sup', [_vm._v("2")])])]) : _vm._e(), _vm.property && _vm.property.viewLabel && (_vm.property.viewLabel[_vm.language.code] || _vm.property.viewLabel.en) ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels53 = _vm.config.labels) === null || _vm$config$labels53 === void 0 ? void 0 : _vm$config$labels53.viewLabel[_vm.language.code]) || ((_vm$config$labels54 = _vm.config.labels) === null || _vm$config$labels54 === void 0 ? void 0 : _vm$config$labels54.viewLabel.en)))]), _c('div', {
    staticClass: "detail__value",
    attrs: {
      "dir": "ltr"
    }
  }, [_vm._v(_vm._s(_vm.property.viewLabel[_vm.language.code]))])]) : _vm._e(), _vm.property.dwelling && _vm.property.dwelling.beds ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels55 = _vm.config.labels) === null || _vm$config$labels55 === void 0 ? void 0 : _vm$config$labels55.dwellingBeds[_vm.language.code]) || ((_vm$config$labels56 = _vm.config.labels) === null || _vm$config$labels56 === void 0 ? void 0 : _vm$config$labels56.dwellingBeds["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.beds))])]) : _vm._e(), _vm.property.dwelling && _vm.property.dwelling.baths ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels57 = _vm.config.labels) === null || _vm$config$labels57 === void 0 ? void 0 : _vm$config$labels57.dwellingBaths[_vm.language.code]) || ((_vm$config$labels58 = _vm.config.labels) === null || _vm$config$labels58 === void 0 ? void 0 : _vm$config$labels58.dwellingBaths["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.baths))])]) : _vm._e(), _vm.property.dwelling && _vm.property.dwelling.cars ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(((_vm$config$labels59 = _vm.config.labels) === null || _vm$config$labels59 === void 0 ? void 0 : _vm$config$labels59.dwellingCars[_vm.language.code]) || ((_vm$config$labels60 = _vm.config.labels) === null || _vm$config$labels60 === void 0 ? void 0 : _vm$config$labels60.dwellingCars["en"])))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.cars))])]) : _vm._e(), _vm.property.dwelling && _vm.property.dwelling.minimumFrontage ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v("Min. Frontage")]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.dwelling.minimumFrontage) + "m")])]) : _vm._e(), (_vm$config$general5 = _vm.config.general) !== null && _vm$config$general5 !== void 0 && _vm$config$general5.showPrice && _vm.property.price && (_vm.property.status !== 'sold' || _vm.property.status === 'sold' && _vm.config.general.showSoldPrice) ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail__label"
  }, [_vm._v(_vm._s(_vm.hasDefaultPropertyLabel ? ((_vm$config$labels61 = _vm.config.labels) === null || _vm$config$labels61 === void 0 ? void 0 : _vm$config$labels61.propertyPrice[_vm.language.code]) || ((_vm$config$labels62 = _vm.config.labels) === null || _vm$config$labels62 === void 0 ? void 0 : _vm$config$labels62.propertyPrice["en"]) : _vm.property.priceLabel))]), _c('div', {
    staticClass: "detail__value"
  }, [_vm._v(_vm._s(_vm.property.price))])]) : _vm._e()]), _c('div', {
    staticClass: "spacer"
  }), _c('div', {
    staticClass: "property-modal__buttons"
  }, [_vm._l(_vm.property.iframes, function (iframe) {
    return _c('button', {
      key: iframe.label,
      staticClass: "touch btn btn--auto",
      on: {
        "click": function click($event) {
          return _vm.$store.commit('actions/SET_IFRAME_URL', iframe.url);
        }
      }
    }, [_c('div', [_vm._v(_vm._s(iframe.label))])]);
  }), _vm.property.associatedPackages && _vm.property.associatedPackages.length ? _c('div', {
    staticClass: "associated-packages"
  }, [_c('button', {
    staticClass: "touch btn btn--auto",
    on: {
      "click": _vm.viewPackages
    }
  }, [_c('div', [_vm._v(_vm._s(((_vm$config$propertyMo = _vm.config.propertyModal) === null || _vm$config$propertyMo === void 0 ? void 0 : _vm$config$propertyMo.associatedPackagesButtonLabel) || "View Packages"))])])]) : _vm._e(), _vm.property.associatedLotPath ? _c('div', {
    staticClass: "associated-packages"
  }, [_c('router-link', {
    staticClass: "touch btn btn--auto",
    attrs: {
      "to": _vm.property.associatedLotPath
    }
  }, [_c('div', [_vm._v("View Lot")])])], 1) : _vm._e(), (_vm$config$propertyMo2 = _vm.config.propertyModal) !== null && _vm$config$propertyMo2 !== void 0 && _vm$config$propertyMo2.showSuitableDwellingsButton && _vm.property.suitableDwellings && _vm.property.suitableDwellings.length ? _c('div', {
    staticClass: "associated-packages"
  }, [_c('router-link', {
    staticClass: "touch btn btn--auto",
    attrs: {
      "to": "".concat(_vm.buildDwellingsPath(_vm.$route), "?lotId=").concat(_vm.property._id)
    }
  }, [_c('div', [_vm._v(_vm._s((_vm$config$propertyMo3 = _vm.config.propertyModal) === null || _vm$config$propertyMo3 === void 0 ? void 0 : _vm$config$propertyMo3.suitableDwellingsButtonLabel))])])], 1) : _vm._e(), _vm.facadeImages.length > 1 ? _c('div', {
    staticClass: "facade"
  }, [_c('div', [_c('button', {
    staticClass: "touch btn btn--auto",
    on: {
      "click": _vm.viewFacades
    }
  }, [_c('span', [_vm._v("View Facades")])])])]) : _vm._e(), _vm.isAddToFavouritesVisible ? [!_vm.isFavourited(_vm.property._id) ? _c('button', {
    staticClass: "btn btn--favourites touch",
    on: {
      "click": function click($event) {
        return _vm.addToFavourites(_vm.property);
      }
    }
  }, [_c('fa', {
    staticClass: "icon",
    attrs: {
      "icon": ['far', 'heart']
    }
  }), _c('div', [_vm._v(_vm._s(_vm.config.labels.addToFavourites[_vm.language.code] || _vm.config.labels.addToFavourites.en))])], 1) : _vm._e(), _vm.isFavourited(_vm.property._id) ? _c('button', {
    staticClass: "btn btn--favourites-remove touch",
    on: {
      "click": function click($event) {
        return _vm.removeFromFavourites(_vm.property);
      }
    }
  }, [_c('fa', {
    staticClass: "icon",
    attrs: {
      "icon": ['far', 'trash']
    }
  }), _c('div', [_vm._v("Remove")])], 1) : _vm._e()] : _vm._e()], 2), _c('div', {
    staticClass: "close"
  }, [_c('button', {
    staticClass: "btn-circle touch",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['far', 'times']
    }
  })], 1)])])]), _vm.showFeatures ? _c('div', {
    staticClass: "property-modal__features",
    attrs: {
      "dir": _vm.language.dir
    }
  }, [(_vm$property$descript = _vm.property.description) !== null && _vm$property$descript !== void 0 && _vm$property$descript[_vm.language.code] || (_vm$property$descript2 = _vm.property.description) !== null && _vm$property$descript2 !== void 0 && _vm$property$descript2['en'] ? _c('div', {
    staticClass: "feature-heading"
  }, [_vm._v(_vm._s(_vm.config.labels.description[_vm.language.code] || _vm.config.labels.description["en"]))]) : _vm._e(), (_vm$property$descript3 = _vm.property.description) !== null && _vm$property$descript3 !== void 0 && _vm$property$descript3[_vm.language.code] || (_vm$property$descript4 = _vm.property.description) !== null && _vm$property$descript4 !== void 0 && _vm$property$descript4['en'] ? _c('div', {
    staticClass: "feature",
    domProps: {
      "innerHTML": _vm._s(_vm.property.description[_vm.language.code] || _vm.property.description['en'])
    }
  }) : _vm._e(), (_vm$property$dwelling = _vm.property.dwelling) !== null && _vm$property$dwelling !== void 0 && (_vm$property$dwelling2 = _vm$property$dwelling.featureList) !== null && _vm$property$dwelling2 !== void 0 && _vm$property$dwelling2[_vm.language.code] || (_vm$property$dwelling3 = _vm.property.dwelling) !== null && _vm$property$dwelling3 !== void 0 && (_vm$property$dwelling4 = _vm$property$dwelling3.featureList) !== null && _vm$property$dwelling4 !== void 0 && _vm$property$dwelling4.en ? _c('div', {
    staticClass: "feature-heading"
  }, [_vm._v(_vm._s(_vm.config.labels.features[_vm.language.code] || _vm.config.labels.features["en"]))]) : _vm._e(), (_vm$property$dwelling5 = _vm.property.dwelling) !== null && _vm$property$dwelling5 !== void 0 && (_vm$property$dwelling6 = _vm$property$dwelling5.featureList) !== null && _vm$property$dwelling6 !== void 0 && _vm$property$dwelling6[_vm.language.code] || (_vm$property$dwelling7 = _vm.property.dwelling) !== null && _vm$property$dwelling7 !== void 0 && (_vm$property$dwelling8 = _vm$property$dwelling7.featureList) !== null && _vm$property$dwelling8 !== void 0 && _vm$property$dwelling8.en ? _c('div', {
    staticClass: "feature-list",
    domProps: {
      "innerHTML": _vm._s(((_vm$property$dwelling9 = _vm.property.dwelling) === null || _vm$property$dwelling9 === void 0 ? void 0 : _vm$property$dwelling9.featureList[_vm.language.code]) || ((_vm$property$dwelling10 = _vm.property.dwelling) === null || _vm$property$dwelling10 === void 0 ? void 0 : _vm$property$dwelling10.featureList['en']))
    }
  }) : _vm._e(), _vm.property.isDisplayHome && _vm.property.displayHomeHours ? _c('div', {
    staticClass: "feature-heading"
  }, [_vm._v(_vm._s(_vm.config.labels.openingHours[_vm.language.code] || _vm.config.labels.openingHours["en"]))]) : _vm._e(), _vm.property.isDisplayHome && _vm.property.displayHomeHours ? _c('div', {
    staticClass: "feature",
    domProps: {
      "innerHTML": _vm._s(_vm.property.displayHomeHours.en)
    }
  }) : _vm._e(), _vm.property.dwelling ? _c('div', [_vm.property.dwelling.builderDescription[_vm.language.code] || _vm.property.dwelling.builderDescription['en'] || _vm.property.dwelling.builderImage ? _c('div', {
    staticClass: "feature-heading"
  }, [_vm._v(_vm._s(_vm.config.labels.dwellingBuilder[_vm.language.code] || _vm.config.labels.dwellingBuilder["en"]))]) : _vm._e(), _vm.property.dwelling.builderImage ? _c('img', {
    staticClass: "property-modal__builder-logo",
    attrs: {
      "src": _vm.$store.state.assetsPath + _vm.property.dwelling.builderImage
    }
  }) : _vm._e(), _vm.property.dwelling.builderDescription[_vm.language.code] || _vm.property.dwelling.builderDescription['en'] ? _c('div', {
    staticClass: "feature",
    domProps: {
      "innerHTML": _vm._s(_vm.property.dwelling.builderDescription[_vm.language.code] || _vm.property.dwelling.builderDescription['en'])
    }
  }) : _vm._e()]) : _vm._e()]) : _vm._e()])]) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }